

import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import KisiKurumForm from "@/components/forms/KisiKurumForm.vue";
import TarafSifatiPicker from "@/components/pickers/TarafSifatiPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import { KisiKurumTuru } from "@/enum/KisiKurumTuru";
import { BorcluEntity } from "@/entity/BorcluEntity";
import { KisiEntity } from "@/entity/KisiEntity";
import { KurumEntity } from "@/entity/KurumEntity";
import { AdresEntity } from "@/entity/AdresEntity";
import { AdresTuruLabel } from "@/enum/AdresTuru";
import { StatusCodeHelper } from "@/helpers/StatusCodeHelper";
import { adresIlceSorunu, ILCE_DUZELTME_ONERISI } from "@/helpers/AdresIlceDenetimi";
import BorcluVekilList from "@/components/lists/BorcluVekilList.vue";
import BorcluVekiliForm from "@/components/forms/BorcluVekiliForm.vue";
import { ItemArrayManagerTableHeader } from "@/interface/TableHeader";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {onUpdated} from "vue";

@Component({
  methods: {onUpdated},
  components: {
    BorcluVekiliForm,
    ItemArrayManager,
    BorcluVekilList,
    FormWrapper,
    Tutar,
    KisiKurumForm,
    TarafSifatiPicker
  }
})
export default class BorcluForm extends Mixins(ObjectInputMixin) {
  @Prop({ required: true }) takipId!: number;
  @Prop() borclular!: Array<BorcluEntity>;
  @Prop({ default: false }) updateBorcluInfo!: boolean;
  @Ref('formWrapper') formWrapper!: FormWrapper;

  searched: boolean = false;
  existings: Array<KisiEntity> | Array<KurumEntity> = [];
  adresler: Array<AdresEntity> = [];
  snackbar:boolean = false;
  adrescheck: boolean = false;
  StatusCodeHelper = new StatusCodeHelper();
  borcluAlertMessage = ''
  borcluAlertVisible = false
  /** Gösterilen uyarı ilçe denetiminden geldiyse metni; sunucu hatalarından ayırmak için. */
  ilceUyarisi: string | null = null

  headers: Array<ItemArrayManagerTableHeader> = [
    { text: "Adı", value: "ad", renderer: (row) => (row?.ad) },
    { text: "Soyad", value: "soyad", renderer: (row) => row?.soyad },
    { text: "Teblig Tarihi", value: "teblig_tarihi", renderer: (row) => this.$helper.tarihStr(row?.teblig_tarihi) }
  ];

  async handleVekiller(){
    const id = this.localValue.kisi?.id || this.localValue.kurum?.id;
    if(id){
      const response = await this.$http.get(`/api/v1/kisi/${id}`);
      this.localValue.vekiller = response.data.borclu_vekilleri || [];
    }

    this.input()
  }
  @Watch('localValue')
  changeLocalValue() {
    if (this.localValue?.kisi?.id || this.localValue?.kurum?.id) {
      this.localValue.taraf_sifati_id = 2;
    }
  }
  mounted() {
    this.adrescheck = false;
    if (this.localValue && this.localValue.id) {
      this.searched = true;
    }
    if (this.borclular) {
      this.existings = this.borclular.map((borclu: BorcluEntity) => borclu.kisi ?? borclu.kurum ?? null);
    }
    if (!this.localValue.taraf_sifati_id) {
      this.localValue.taraf_sifati_id = 2;
      this.input();
    }
  }
  @Watch('snackbar')
    adrescheckChanged() {
    if(!this.snackbar){
      this.formWrapper.onFly=false
    }
  }

  @Watch("borclular.length")
  onItemsChange() {
    this.existings = this.borclular.map((borclu: BorcluEntity) => borclu.kisi ?? borclu.kurum ?? null);
  }
  onUpdateSearched(value: boolean) {
    this.searched = value;
  }

  setDefaultFields() {
    if (!this.localValue.sorumluluk_siniri_var_mi) {
      this.localValue.sorumluluk_siniri_var_mi = false;
    }
    if (!this.localValue.tereke_mi) {
      this.localValue.tereke_mi = false;
    }
  }

  async onKisiKurumChange() {
    try {
      const kisiId = this.localValue.kisi?.id
      const kurumId = this.localValue.kurum?.id;
      if (kisiId && kisiId !== 0) {
        const response = await this.$http.get(`/api/v1/kisi/${kisiId}`);
        this.localValue.vekiller = response.data.borclu_vekilleri || [];
        if (this.localValue.vekiller.length === 0) {
          console.warn("No representatives found.");
        }
        this.searched = true;
        this.$emit("selected", response.data);
      } else if (kurumId && kurumId !== 0) {
        const response = await this.$http.get(`/api/v1/kurum/${kurumId}`);
        this.localValue.vekiller = response.data.borclu_vekilleri || [];
        if (this.localValue.vekiller.length === 0) {
          console.warn("No representatives found.");
        }
        this.searched = true;
        this.$emit("selected", response.data);
      }else{
        this.searched = true;
        this.localValue.vekiller = [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  onClose() {
    this.formWrapper.onFly = false;
    this.borcluAlertMessage = ''
    this.borcluAlertVisible = false
    this.$emit("onClose");
  }

  resetForm() {
    if (!this.localValue.id) {
      delete this.localValue.kisi;
      delete this.localValue.kurum;
      this.localValue.kisi_kurum_turu = KisiKurumTuru.sahis;
      this.searched = false;
    }
    this.borcluAlertMessage = ''
    this.borcluAlertVisible = false
    this.$emit("onClose");
  }

  /*async vekilUpdate(borcluID: number) {
    for (const vekil of this.localValue.vekiller) {
      await this.$http.post('/api/v1/borclu/' + borcluID + '/vekil', vekil).catch(error => StatusCodeHelper.error(error));

    }

  }
*/
  async save() {
    this.formWrapper.onFly = true;
    this.setDefaultFields();
    this.$store.state.createTcKimlikErrors = [];


    if((this.localValue.kisi && this.localValue.kisi.adresler.length > 0) || (this.localValue.kurum && this.localValue.kurum.adresler.length > 0)) {
      const ilceSorunu = this.ilceSorunuMesaji();
      if (ilceSorunu) {
        this.ilceUyarisi = ilceSorunu;
        this.borcluAlertMessage = ilceSorunu;
        this.borcluAlertVisible = true;
        this.formWrapper.onFly = false;
        return;
      }
      this.borcluAlertVisible = false;
      // Güncelleme yalnızca kayıtlı borçlu (id) içindir. kisi_id/kurum_id aşağıda ekleme
      // sırasında da atandığından, başarısız bir eklemeden sonraki denemede
      // PUT /borclu/undefined (404) gidiyordu.
      if (this.localValue.id) {
        await this.updateBorclu();
      } else {
        if (this.localValue.kisi_kurum_turu === KisiKurumTuru.sahis) {
          if (this.localValue.kisi.id === 0) {
            this.localValue.kisi.id = null;
          }
          if (this.localValue.kisi.id == null) {
            await this.insertBorclu();
          } else {
            this.localValue.kisi_id = this.localValue.kisi.id;
            await this.insertBorclu();
          }
        } else if (this.localValue.kisi_kurum_turu === KisiKurumTuru.sirket) {
          if (this.localValue.kurum.id === 0) {
            this.localValue.kurum.id = null;
          }
          if (this.localValue.kurum.id == null) {
            await this.insertBorclu();
          } else {
            this.localValue.kurum_id = this.localValue.kurum.id;
            await this.insertBorclu();
          }
        }
      }
    }else{
      this.snackbar=true
    }
  }

  async insertBorclu() {
    try {
      // Hafızadan seçilen kayıtta elle tamamlanan adres bilgisi (ör. ilçe)
      // borçlu ekleme reddedilse bile kaybolmasın diye POST'tan önce yazılır.
      if (!(await this.adresleriKaydet())) {
        return;
      }

      const response = await this.$http.post(
          `/api/v1/takip/${this.takipId}/borclu`,
          this.localValue
      );
      const borcluID = response.data.id;

      if (
          (this.localValue.kisi && this.localValue.kisi.id == null) ||
          (this.localValue.kurum && this.localValue.kurum.id == null)
      ) {
        /*await this.vekilUpdate(borcluID).catch(error => {
          console.error("Vekil ekleme sırasında hata oluştu:", error);
        });*/
      }

      this.$emit("onSuccess");
      this.resetForm();

    } catch (error) {
      this.borcluAlertMessage = this.sunucuHataMesaji(error)
      this.borcluAlertVisible = true
      this.StatusCodeHelper.error(error);
    } finally {
      this.formWrapper.onFly = false;
    }
  }

  /**
   * Yurt içi adreste ilçe eksik, geçersiz ya da başka ilinse borçlu eklenmez. Hafızadaki
   * aktarım kayıtlarında (ör. İstanbul/MERKEZ) ilçe boş kalabiliyor; böyle eklenen borçlu
   * UYAP XML'ine ilçesiz çıkıp takip açılışını bozuyordu (DEV-2726).
   */
  ilceSorunuMesaji(): string | null {
    const adresler: AdresEntity[] = this.localValue.kisi?.adresler || this.localValue.kurum?.adresler || [];
    for (const adres of adresler) {
      const sorun = adresIlceSorunu(adres);
      if (sorun) {
        const tur = AdresTuruLabel[adres.adres_tur_id] || 'Adres';
        return `Borçlunun ${tur} kaydında ${sorun}. ${ILCE_DUZELTME_ONERISI}`;
      }
    }
    return null;
  }

  /**
   * Kalemle ilçe seçilince (adres listesi `load` yayar) kayıt denemesinden kalan ilçe uyarısı
   * güncellenir ya da kalkar. Seçilen kurum/kişi nesnesi reaktif olmadığından izleyici
   * (watch) bu değişikliği görmüyor. Sunucu hatası gibi başka uyarılara dokunulmaz.
   */
  ilceUyarisiniTazele() {
    if (!this.borcluAlertVisible || this.borcluAlertMessage !== this.ilceUyarisi) {
      return;
    }
    this.ilceUyarisi = this.ilceSorunuMesaji();
    if (this.ilceUyarisi) {
      this.borcluAlertMessage = this.ilceUyarisi;
    } else {
      this.borcluAlertVisible = false;
    }
  }

  /**
   * Uyarı kutusunda sunucunun gerçek hatasını gösterir. Önceden her hata
   * "zaten ekli" olarak yazıldığı için asıl sebep (ör. eksik alan) gizleniyordu.
   */
  sunucuHataMesaji(error: any): string {
    const data = error?.response?.data;
    if (data?.error) return data.error;
    // Doğrulama hatasında `message` yalnızca "The given data was invalid." olur;
    // asıl sebep `errors` altındadır.
    const ilkHata: any = data?.errors ? Object.values(data.errors)[0] : null;
    if (Array.isArray(ilkHata) && ilkHata.length) return ilkHata[0];
    if (data?.message) return data.message;
    return 'Borçlu eklenirken bir hata oluştu.';
  }

  /**
   * Adresleri yazar; biri reddedilirse borçlu eklemeye geçmeden sebebi gösterir.
   * Aktarımdan geçersiz ilçeyle gelen adres (ekranda ilçesi boş) burada 422 alır.
   */
  async adresleriKaydet(): Promise<boolean> {
    try {
      await this.handleAdresRequests(true);
      return true;
    } catch (error) {
      this.borcluAlertMessage = 'Adres kaydedilemedi: ' + this.sunucuHataMesaji(error)
          + ' Adresi kalem simgesiyle açıp il ve ilçeyi yeniden seçin.';
      this.borcluAlertVisible = true;
      return false;
    }
  }

  async updateBorclu() {
    try {
      await this.$http.put(
          `/api/v1/borclu/${this.localValue.id}`,
          this.localValue
      );
      await this.handleAdresRequests();


      /*this.vekilUpdate(this.localValue.id).catch(error => {
        console.error("Vekil güncelleme sırasında hata oluştu:", error);
      });*/

      this.$emit("onSuccess");
      this.resetForm();

    } catch (error) {
      this.StatusCodeHelper.error(error);
    } finally {
      this.formWrapper.onFly = false;
    }
  }

  /**
   * @param yeniAdresleriKaydet Güncelleme yolunda sunucu yeni adresleri kendisi açtığından
   *   orada verilmez (çift kayıt olur).
   */
  async handleAdresRequests(yeniAdresleriKaydet: boolean = false) {
    const adresler: AdresEntity[] = this.localValue.kisi?.adresler || this.localValue.kurum?.adresler || [];
    for (const adres of adresler) {
      if (adres.id) {
        await this.$http.put(`/api/v1/adres/${adres.id}`, adres);
      }
    }
    if (yeniAdresleriKaydet) {
      await this.yeniAdresleriKaydet();
    }
  }

  /**
   * Hafızadan seçilen kişi/kuruma formda eklenen adresleri kaydeder. Borçlu ekleme ucu
   * kayıtlı tarafın adreslerine dokunmadığı için bunlar önceden sessizce kayboluyordu.
   * Yeni taraf (id yok) için adresleri borçlu ekleme ucu açar; burada atlanır.
   */
  async yeniAdresleriKaydet() {
    const sirketMi = this.localValue.kisi_kurum_turu === KisiKurumTuru.sirket;
    const taraf = sirketMi ? this.localValue.kurum : this.localValue.kisi;
    if (!taraf?.id) {
      return;
    }
    const yeniler = (taraf.adresler || []).filter((adres: AdresEntity) => !adres.id);
    if (!yeniler.length) {
      return;
    }
    const tarafYolu = `/api/v1/${sirketMi ? 'kurum' : 'kisi'}/${taraf.id}`;
    for (const adres of yeniler) {
      await this.$http.post(`${tarafYolu}/adres`, adres);
    }
    // Yeni adreslerin id'si alınır ki borçlu eklenemeyip yeniden denenirse ikinci kez açılmasın.
    // Dizi yerinde güncellenir: adres listesi aynı diziyi paylaşır. Yeni dizi atanınca ekleme
    // başarısız olduktan sonra listede yapılan ilçe düzeltmesi buraya ulaşmıyor, tekrar
    // denemede eski ilçe geri yazılıyordu (DEV-2726).
    // Kurum ucu kurumun kendisini, kişi ucu `{kisi, borclu_vekilleri}` döner (KisiKurumForm de
    // `response.data.kisi` okur). Kişide `data.adresler` olmadığından liste boşalıyor, yeniden
    // denemede adres ikinci kez açılıyordu. Liste gelmezse girilen adreslere dokunulmaz.
    const response = await this.$http.get(tarafYolu);
    const guncelAdresler = (sirketMi ? response.data : response.data?.kisi)?.adresler;
    if (Array.isArray(guncelAdresler)) {
      taraf.adresler.splice(0, taraf.adresler.length, ...guncelAdresler);
    }
  }
}
